export default class SettingsDesc {
  /**
   * @param {Object<String>}
   */
  constructor({ name }) {
    this.name = name;
  }

  /**
   * Get name
   * @returns {String}
   */
  getName() {
    return this.name;
  }
}
